module.exports = __webpack_public_path__ + "img/paziente.8e74e9ee.jpeg";